<template>
    <div>
        <figure class="analog-clock">
            <figcaption class="analog-clock__face">
              <span v-for="n in 60"
                    :key="n"
                    class="analog-clock__notch"
                    :class="{ '-long': !(n % 5) }"
                    :style="{ transform: `rotate(${n * 6}deg)` }">
              </span>
            </figcaption>
            <span class="analog-clock__hand -seconds" :style="seconds"></span>
            <span class="analog-clock__hand -minutes" :style="minutes"></span>
            <span class="analog-clock__hand -hours" :style="hours"></span>
        </figure>
    </div>
</template>

<script>
    import DayNight from 'ol-ext/source/DayNight';
    import {Vector as VectorLayer} from 'ol/layer';
    import {Fill, Style} from 'ol/style';

    export default {
        name: "Time",
        data() {
            return {
                map: this.$store.getters["map/getMap"],
                rotation: { hours: 0, minutes: 0, seconds: 0 },
                tick: 0,
                time: { hours: 0, minutes: 0, seconds: 0 }
            }
        },
        computed: {
            hours() {
                return { transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.hours}deg)` }
            },
            minutes() {
                return { transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.minutes}deg)` }
            },
            seconds() {
                return { transform: `translate3d(-50%, 0, 0) rotate(${this.rotation.seconds}deg)` }
            }
        },
        watch: {
            tick() {
                this.rotation.seconds += 6;
                this.rotation.minutes += 0.1;
            },
            'time.minutes'(to, from) {
                if (from === to) return;
                this.rotation.hours += 0.5;
            }
        },
        mounted() {
            const loader = this.$loading.show({
                loader: "dots",
            });
            setTimeout(function () {
                loader.hide();
            }, 700);

            // DayNight source
            let vectorSource = new DayNight({});
            this.map.addLayer(new VectorLayer({
                source: vectorSource,
                opacity: .5,
                style: new Style({
                    fill: new Fill({
                        color: [0,0,0]
                    })
                })
            }));
            vectorSource.refresh();

            this.updateTime(new Date());
            let date = new Date();
            let [h, m, s] = [date.getHours(), date.getMinutes(), date.getSeconds()];
            this.rotation = {
                hours: (h * 30) + (m * 0.5),
                minutes: (m * 6) + (s * 0.1),
                seconds: s * 6
            };
        },
        methods : {
            updateTime(time) {
                this.tick++;
                this.time = {
                    hours: time.getHours(),
                    minutes: time.getMinutes(),
                    seconds: time.getSeconds()
                };

                setTimeout(() => this.updateTime(new Date()), 1000 - new Date().getMilliseconds())
            }
        }
    }
</script>

<style>

</style>

<style scoped>
    .analog-clock {
        top: 120px;
        left: 50px;
        width: 200px;
        height: 200px;
        position: absolute;
        border-radius: 100%;
        background-color: white;
        -webkit-transform: translate3d(-1.5rem, -50%, 0);
        transform: translate3d(-1.5rem, -50%, 0);
        -webkit-filter: drop-shadow(0 0.125rem 0.5rem rgba(0, 0, 0, 0.1));
        filter: drop-shadow(0 0.125rem 0.5rem rgba(0, 0, 0, 0.1));
    }
    @media (max-width: 560px) {
        .analog-clock {
            margin-top: 70px;
        }
    }
    .analog-clock::after {
        top: 50%;
        left: 50%;
        content: '';
        width: 2.5%;
        height: 2.5%;
        position: absolute;
        border-radius: 100%;
        background-color: #edbec5;
        -webkit-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
    }
    .analog-clock__face {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
    .analog-clock__notch {
        -webkit-transform-origin: 50% 100%;
        transform-origin: 50% 100%;
        position: absolute;
        width: 1px;
        height: 49%;
        bottom: 50%;
        left: 50%;
    }
    .analog-clock__notch::after {
        content: '';
        width: 100%;
        height: 2.5%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #b6c3c9;
    }
    .analog-clock__notch.-long::after {
        width: 2px;
        height: 7.5%;
    }
    .analog-clock__hand {
        -webkit-transform-origin: 50% 100%;
        transform-origin: 50% 100%;
        background-color: #7392a0;
        position: absolute;
        width: 2px;
        height: 40%;
        bottom: 50%;
        left: 50%;
        border-radius: 2px;
        -webkit-transition: -webkit-transform 1s linear;
        transition: -webkit-transform 1s linear;
        transition: transform 1s linear;
        transition: transform 1s linear, -webkit-transform 1s linear;
    }
    .analog-clock__hand::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 10%;
        background-color: inherit;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
    .analog-clock__hand.-hours {
        height: calc(100% / 3);
        width: 3px;
        border-radius: 3px;
        -webkit-transition: -webkit-transform 60s linear;
        transition: -webkit-transform 60s linear;
        transition: transform 60s linear;
        transition: transform 60s linear, -webkit-transform 60s linear;
    }
    .analog-clock__hand.-seconds {
        width: 1px;
        height: 45%;
        border-radius: 0;
        background-color: #edbec5;
        -webkit-transition: -webkit-transform 100ms cubic-bezier(0.6, 0.05, 0, 1.6);
        transition: -webkit-transform 100ms cubic-bezier(0.6, 0.05, 0, 1.6);
        transition: transform 100ms cubic-bezier(0.6, 0.05, 0, 1.6);
        transition: transform 100ms cubic-bezier(0.6, 0.05, 0, 1.6), -webkit-transform 100ms cubic-bezier(0.6, 0.05, 0, 1.6);
    }
    .analog-clock__hand.-seconds::after {
        height: 12.5%;
    }

    .text-clock {
        display: -webkit-box;
        display: flex;
        top: 50%;
        left: 50%;
        font-size: 3rem;
        position: absolute;
        color: #99dcf9;
        -webkit-transform: translate3d(1.5rem, -50%, 0);
        transform: translate3d(1.5rem, -50%, 0);
        white-space: nowrap;
    }
    .text-clock__col {
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        justify-content: space-around;
        text-align: center;
        line-height: 1.1;
        padding: 0.5rem 0.5rem 0.65rem;
    }
    .text-clock__col.-meridiem {
        text-transform: uppercase;
        font-size: 0.85em;
        background-color: #7392a0;
        color: white;
        font-weight: 500;
        box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
    }
    .text-clock__row {
        -webkit-box-flex: 1;
        flex: 1 0 0;
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
    }
</style>
